import type { THeroImageTypes } from '../types';

export const useHeroLayout = (
  mediaType: 'image' | 'loopingVideo' | 'videoModal' | 'rive' | null,
  imageType: THeroImageTypes,
  embeddedForm: 'none' | 'signup' | 'signupTwoColumn' | 'signupInvisibleReCaptcha' | 'demo' | 'demoHubSpot' | 'kform' | 'hubspotform' | 'signupSimple',
  hasMedia: boolean,
  textAlignment: 'center' | 'left'
) => {
  const layout: THeroImageTypes = ['loopingVideo', 'videoModal'].includes(mediaType || '') ? 'vertical' : imageType;
  const isTwoColumn = embeddedForm === 'none' && (!hasMedia || imageType === 'vertical');
  const textAlign = ((!hasMedia && embeddedForm === 'none') || (imageType === 'horizontal' && embeddedForm === 'none')) && textAlignment === 'center' ? 'center' : '';

  return {
    layout,
    isTwoColumn,
    textAlign,
  };
};
